import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';

import { withOverlayControls } from '@eb/eds-structure';
import { clickCTASeasonal } from '../../redux/content/actions';

import { HeaderBackgroundContainer } from '../HeaderBackgroundContainer';

import { HeaderTitle } from '../../components/HeaderTitle';
import { ImageAttribution } from '../../components/ImageAttribution';

import { HEADER_PROPTYPES } from './constants';

import './Header.scss';

export class Header extends Component {
    static propTypes = {
        isLoading: PropTypes.bool.isRequired,
        // eslint-disable-next-line
        history: PropTypes.object,
        header: PropTypes.shape(HEADER_PROPTYPES),
        clickCTASeasonal: PropTypes.func,
    };

    render() {
        const { header = {}, isLoading, clickCTASeasonal } = this.props;

        const feedHeaderClassNames = classNames(['feed-header']);

        let titleComponent = null;

        if (!isLoading) {
            titleComponent = (
                <HeaderTitle
                    header={header}
                    clickCTASeasonal={clickCTASeasonal}
                />
            );
        }

        return (
            <section className={feedHeaderClassNames}>
                <div className="feed-header__bg-box" />
                <HeaderBackgroundContainer
                    type="MainHeaderBackground"
                    isSeasonal={header.shouldShowCustomContent}
                />

                <div className="feed-header__content">
                    <div>{titleComponent}</div>

                    <ImageAttribution attribution={header.attribution} />
                </div>
            </section>
        );
    }
}

const _mapStateToProps = ({ header, app }) => ({
    header,
    isLoading: app.loadingState && app.loadingState.isFeLoading,
});

const _mapDispatchToProps = {
    clickCTASeasonal,
};

export default withOverlayControls(
    connect(_mapStateToProps, _mapDispatchToProps)(Header),
);
